module.exports = __webpack_public_path__ + "img/advantage-1.8ab8fc72.png";